module.exports = __webpack_public_path__ + "static/uxpin_notepad_collection_1-454bb88278e1174882fc6bdddb6a5810.png";